import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const Loader = () => (
  <div className="flex min-h-[50vh] items-center justify-center" data-testid="page-loader">
    <div className="h-10 w-10 animate-spin rounded-full border-2 border-amber-500 border-t-transparent" />
  </div>
);

export const ProtectedRoute = ({ children, admin }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to={`/accedi?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};
